export default __webpack_public_path__ + "static/media/bnr-rzeus-pc.b1d5df67.jpg";